// Classifies the free-text "dietary" field of a guest so the plan can flag it
// at a glance. Order matters: allergies come first because they are the only
// category where a missed constraint is a safety issue.
const normalize = (value) => String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

const CATEGORIES = [
  { key: 'allergy', label: 'Allergie', color: '#dc2626', test: /allerg|anaphyl|arachide|cacahu|noix|fruits a coque|oeuf|crustace|fruits de mer|poisson|soja|sesame|celeri|moutarde/ },
  // An intolerance is not an allergy: it must not raise the kitchen's allergy alert.
  { key: 'intolerance', label: 'Intolérance', color: '#c2410c', test: /lactose|intoleran|sans lait|sans sucre|diabet/ },
  { key: 'gluten', label: 'Sans gluten', color: '#d97706', test: /gluten|coeliaque|celiaque/ },
  { key: 'vegan', label: 'Vegan', color: '#0d9488', test: /vegan|vegetalien/ },
  { key: 'vegetarian', label: 'Végétarien', color: '#16a34a', test: /vegetarien|veggie|sans viande/ },
  { key: 'halal', label: 'Halal', color: '#2563eb', test: /halal/ },
  { key: 'kosher', label: 'Casher', color: '#7c3aed', test: /casher|kasher|kosher/ },
];

/** Category for a dietary note, or null when the note is empty or "none". */
export function dietaryCategory(note) {
  const text = normalize(note).trim();
  if (!text || /^(aucun|aucune|rien|non|ras|n\/a|-)$/.test(text)) return null;
  const match = CATEGORIES.find((category) => category.test.test(text));
  return match
    ? { key: match.key, label: match.label, color: match.color }
    : { key: 'other', label: 'Régime', color: '#6b7280' };
}
